/*
 * @Author: wzc
 * @Date: 2025-01-09 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins 亚冬会
 * @LastEditTime: 2025-01-09 10:42:36
 */

import bigSports_mixin from '@mixins/compreSportsMeet/AWG/bigSportsList_mixin.js'
export default {
  mixins: [bigSports_mixin],
  data() {
    return {
      containerFullClassName: 'containerFull_CSMeet_AWG',
      defaultPath: ['compreSportsMeet', 'asianWinterGames', 'schedule'],
      axiosBaseUrl: '/sog', //'/awg',
      sportCompetitionType: 'compreSportsMeet_AWG', //暂时不加具体中网|汤尤杯这种赛事区别，如果需要后面补字段即可【tennis_chinaOpen,badminton_thomasAndUber, compreSportsMeet_ASG】
      themeSeasonArr: [
        {
          sidArr: ['AWG2025'],
          themeIndex: 0,
        },
      ],
    }
  },
}
